import styled from 'styled-components';

export const HoverPanelItem = styled.li`
  align-items: center;
  cursor: pointer;

  background-color: ${({ theme }) => theme.boxbg};
  border: 1px solid transparent;

  display: ${({ hidden }) => { hidden ? 'none' : 'flex'; }};
  margin: 1px .1em;
  padding:0;
  position: relative;

  padding-left: 3px;
  padding-right: 20px;
  margin-left: 5px;
  cursor: pointer;
  line-height: 16px;
  & >i{
    font-size: 13px;
    margin-left: 3px;
    padding: 0 6px 0 3px;
    line-height: 16px;
    margin-right: -1px;
    position: absolute;
    top: 0;
    bottom: 0;
    right: 0;

  }
  & :hover{
    border-color: #deac37;
    color: #deac37;
  }

  & :hover i{
    background: #deac37;
    color: #fff;
  }
`;